import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { configService } from '../services/api';

export default function Navbar() {
  const { user, logout, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [logoUrl, setLogoUrl] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const url = configService.getLogoUrl();
    fetch(url).then(r => { if (r.ok) setLogoUrl(url + '?t=' + Date.now()); }).catch(()=>{});
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => { logout(); navigate('/'); };
  const active = path => location.pathname === path;

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      await configService.uploadLogo(file);
      setLogoUrl(configService.getLogoUrl() + '?t=' + Date.now());
      alert('✅ Logo actualizado correctamente');
    } catch (err) {
      alert('Error al subir el logo');
    }
  };

  const navBtn = (isActive) => ({
    background: isActive ? '#a0522d' : 'transparent',
    color: '#fff',
    border: 'none',
    padding: isMobile ? '10px 0' : '6px 9px',
    borderRadius: isMobile ? 0 : 6,
    cursor: 'pointer',
    fontSize: isMobile ? 11 : 12.5,
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    alignItems: 'center',
    gap: isMobile ? 3 : 5,
    flex: isMobile ? 1 : 'none',
    borderBottom: isActive ? '3px solid #f59e0b' : '3px solid transparent',
  });

  return (
    <>
      <nav style={{
        background: '#5c3d2e',
        color: '#fff',
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 54,
        position: 'sticky',
        top: 0,
        zIndex: 100,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      }}>
        <div
          style={{ fontWeight: 800, fontSize: 17, letterSpacing: 1, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
          onClick={() => navigate('/dashboard')}
        >
          {logoUrl
            ? <img src={logoUrl} alt="Logo" style={{ height: 38, objectFit: 'contain' }} onError={() => setLogoUrl(null)} />
            : <span>🪑</span>
          }
          {!isMobile && <span>Terrasol</span>}
        </div>

        {!isMobile && !loading && (
          <div style={{ display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: 'center', flex: 1 }}>
            {user?.role !== 'inventario' && user?.role !== 'chofer' && <button style={navBtn(active('/dashboard'))} onClick={() => navigate('/dashboard')}>📊 Órdenes</button>}
            {['admin','vendedor'].includes(user?.role) && <button style={navBtn(active('/nueva-orden'))} onClick={() => navigate('/nueva-orden')}>+ Nueva Orden</button>}
            {user?.role === 'admin' && <button style={navBtn(active('/entregas'))} onClick={() => navigate('/entregas')}>🚚 Entregas</button>}
            {user?.role === 'admin' && <button style={navBtn(active('/produccion'))} onClick={() => window.open('/produccion', '_blank')}>🔧 Producción</button>}
            {(user?.role === 'admin' || user?.id === 9) && <button style={navBtn(active('/taller'))} onClick={() => navigate('/taller')}>🧵 Taller</button>}
            {(user?.role === 'admin' || user?.id === 9) && <button style={navBtn(active('/pagos-taller'))} onClick={() => navigate('/pagos-taller')}>💰 Pagos Taller</button>}
            {user?.role === 'admin' && <button style={navBtn(active('/bodega'))} onClick={() => navigate('/bodega')}>🏭 Bodega</button>}
            {user?.role === 'admin' && <button style={navBtn(active('/reportes'))} onClick={() => window.open('/reportes', '_blank')}>📈 Reportes</button>}
            {['admin','vendedor'].includes(user?.role) && <button style={navBtn(active('/garantias'))} onClick={() => navigate('/garantias')}>🛡️ Garantías</button>}
            {['admin','vendedor'].includes(user?.role) && <button style={navBtn(active('/clientes'))} onClick={() => navigate('/clientes')}>👥 Clientes</button>}
            {['admin','vendedor','inventario'].includes(user?.role) && <button style={navBtn(active('/inventario'))} onClick={() => navigate('/inventario')}>📦 Inventario</button>}
            {(user?.role === 'chofer' || user?.es_chofer) && <button style={navBtn(active('/mis-entregas'))} onClick={() => navigate('/mis-entregas')}>🚚 Mis Entregas</button>}
          </div>
        )}

        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 12, opacity: 0.8 }}>👤 {isMobile ? user?.name?.split(' ')[0] : user?.name}</span>
          <button
            style={{ background: '#c0392b', color: '#fff', border: 'none', padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}
            onClick={handleLogout}
          >Salir</button>
        </div>
      </nav>

      {isMobile && (
        <div style={{
          background: '#5c3d2e',
          display: 'flex',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          position: 'sticky',
          top: 54,
          zIndex: 99,
        }}>
          {user?.role !== 'inventario' && user?.role !== 'chofer' && (
            <button style={navBtn(active('/dashboard'))} onClick={() => navigate('/dashboard')}>
              <span style={{ fontSize: 18 }}>📊</span>
              <span>Órdenes</span>
            </button>
          )}
          {user?.role === 'admin' && (
            <button style={navBtn(active('/entregas'))} onClick={() => navigate('/entregas')}>
              <span style={{ fontSize: 18 }}>🚚</span>
              <span>Entregas</span>
            </button>
          )}
          {user?.role === 'admin' && (
            <button style={navBtn(active('/produccion'))} onClick={() => navigate('/produccion')}>
              <span style={{ fontSize: 18 }}>🔧</span>
              <span>Producción</span>
            </button>
          )}
          {user?.role === 'admin' && (
            <button style={navBtn(active('/reportes'))} onClick={() => navigate('/reportes')}>
              <span style={{ fontSize: 18 }}>📈</span>
              <span>Reportes</span>
            </button>
          )}
          {['admin','vendedor'].includes(user?.role) && (
            <button style={navBtn(active('/nueva-orden'))} onClick={() => navigate('/nueva-orden')}>
              <span style={{ fontSize: 22, color: "#f59e0b", fontWeight: "bold", lineHeight: 1 }}>+</span>
              <span>Nueva Orden</span>
            </button>
          )}
          {['admin','vendedor'].includes(user?.role) && (
            <button style={navBtn(active('/garantias'))} onClick={() => navigate('/garantias')}>
              <span style={{ fontSize: 18 }}>🛡️</span>
              <span>Garantías</span>
            </button>
          )}
          {['admin','vendedor'].includes(user?.role) && (
            <button style={navBtn(active('/clientes'))} onClick={() => navigate('/clientes')}>
              <span style={{ fontSize: 18 }}>👥</span>
              <span>Clientes</span>
            </button>
          )}
          {['admin','vendedor','inventario'].includes(user?.role) && (
            <button style={navBtn(active('/inventario'))} onClick={() => navigate('/inventario')}>
              <span style={{ fontSize: 18 }}>📦</span>
              <span>Inventario</span>
            </button>
          )}
          {(user?.role === 'chofer' || user?.es_chofer) && (
            <button style={navBtn(active('/mis-entregas'))} onClick={() => navigate('/mis-entregas')}>
              <span style={{ fontSize: 18 }}>🚚</span>
              <span>Mis Entregas</span>
            </button>
          )}
        </div>
      )}
    </>
  );
}
